import { createStore } from "./storeCreator"

interface FavoritesState {
    favorites: any[]
    setFavorites: (value: any) => void
}

export const favoritesStore = createStore<FavoritesState>(
    (set) => ({
        favorites: [],
        setFavorites: (value: any) => set({ favorites: value?.edges }),
    }),
    { name: 'favorites-store' },
)